import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable, signal } from '@angular/core';

/**
 * Custom overlay container for the dialog component.
 * Ensures CDK overlays and ng-primitives select/dropdown portals render inside the dialog
 * (HTML dialog top layer) instead of document.body.
 */

@Injectable({
  providedIn: 'root',
})
export class DialogOverlayContainer extends OverlayContainer {
  private readonly containerStack: HTMLElement[] = [];

  /** Signal so dropdown computed re-runs when dialog opens/closes (reactive container). */
  readonly currentContainer = signal<HTMLElement | null>(null);

  addContainer(container: HTMLElement): void {
    if (this._containerElement) {
      this.containerStack.push(this._containerElement);
    }
    this._containerElement = container;
    this.currentContainer.set(container);
  }

  removeContainer(): void {
    this._containerElement = this.containerStack.pop() as HTMLElement;
    this.currentContainer.set(this._containerElement ?? null);
  }

  /** Current overlay container element (for ng-primitives select/dropdown container option). */
  getCurrentContainer(): HTMLElement | null {
    return this._containerElement ?? null;
  }
}
